import { render, staticRenderFns } from "./Hist.vue?vue&type=template&id=3f6b885e&"
import script from "./Hist.vue?vue&type=script&setup=true&lang=js&"
export * from "./Hist.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Hist.scss?vue&type=style&index=0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports